(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function(){
  function init(scope){
    scope.querySelectorAll('[data-dh-collection]').forEach(function(root){
      if(root.dataset.initialized)return;
      root.dataset.initialized='true';
      var sequence=0,controller=null;
      var results=root.querySelector('[data-collection-results]');
      var status=root.querySelector('[data-collection-status]');
      function cleanUrl(href){
        var url=new URL(href,location.href),current=new URL(location.href);
        current.searchParams.forEach(function(value,key){
          if(!key.startsWith('filter.')&&!['sort_by','page','section_id'].includes(key)&&!url.searchParams.has(key))url.searchParams.append(key,value);
        });
        url.searchParams.delete('section_id');
        return url;
      }
      function formUrl(form){
        var url=cleanUrl(form.action),data=new FormData(form);
        Array.from(url.searchParams.keys()).forEach(function(key){if(key.startsWith('filter.')||key==='sort_by'||key==='page')url.searchParams.delete(key);});
        if(form.dataset.filtersEnabled!=='true')new URL(location.href).searchParams.forEach(function(value,key){if(key.startsWith('filter.'))url.searchParams.append(key,value);});
        data.forEach(function(value,key){if(String(value).trim()!=='')url.searchParams.append(key,value);});
        url.hash='';
        return url;
      }
      function request(url,append,historyMode,skippedEmptyPages){
        skippedEmptyPages=skippedEmptyPages||0;
        var token=++sequence;
        var focusedId=root.contains(document.activeElement)?document.activeElement.id:'';
        if(controller)controller.abort();
        controller=new AbortController();
        root.setAttribute('aria-busy','true');
        status.textContent=root.dataset.loadingText;
        var fetchUrl=new URL(url);fetchUrl.searchParams.set('section_id',root.dataset.sectionId);
        return fetch(fetchUrl.toString(),{signal:controller.signal}).then(function(response){
          if(!response.ok)throw new Error('Collection request failed');
          return response.text();
        }).then(function(html){
          if(token!==sequence||!root.isConnected)return;
          var doc=new DOMParser().parseFromString(html,'text/html');
          var nextRoot=doc.getElementById(root.id),next=nextRoot&&nextRoot.querySelector('[data-collection-results]');
          if(!next)throw new Error('Collection results missing');
          if(append){
            var grid=results.querySelector('#CollGrid'),nextGrid=next.querySelector('#CollGrid');
            if(!grid||!nextGrid)throw new Error('Collection grid missing');
            var pagination=results.querySelector('[data-collection-pagination]'),nextPagination=next.querySelector('[data-collection-pagination]');
            var restoreAppendFocus=pagination&&pagination.contains(document.activeElement)&&document.activeElement.matches('[data-loadmore]');
            var firstAdded=null;
            var incomingCards=Array.from(nextGrid.children).filter(function(card){return card.classList.contains('product-card');});
            if(incomingCards.length)grid.querySelectorAll('.dh-collempty').forEach(function(empty){empty.remove();});
            incomingCards.forEach(function(card){var added=document.importNode(card,true);if(!firstAdded)firstAdded=added;grid.appendChild(added);});
            if(pagination&&nextPagination)pagination.replaceWith(document.importNode(nextPagination,true));
            if(!incomingCards.length){
              var continueLink=nextPagination&&nextPagination.querySelector('[data-loadmore]');
              var continueUrl=continueLink&&cleanUrl(continueLink.href);
              if(continueUrl&&continueUrl.toString()!==url.toString()&&skippedEmptyPages<3)return request(continueUrl,true,historyMode,skippedEmptyPages+1);
              if(!grid.querySelector('.product-card')){
                grid.innerHTML=nextGrid.innerHTML;
              }
            }
            if(restoreAppendFocus&&firstAdded){var appendedLink=firstAdded.querySelector('a[href]');if(appendedLink)appendedLink.focus({preventScroll:true});}
          }else{
            results.innerHTML=next.innerHTML;
            if(historyMode==='push')history.pushState({},'',url.toString());
            var focusTarget=focusedId&&document.getElementById(focusedId);
            if(!focusTarget)focusTarget=results.querySelector('[data-collection-count]');
            if(historyMode==='push'&&focusTarget)focusTarget.focus({preventScroll:true});
          }
          root.removeAttribute('aria-busy');
          status.textContent=root.dataset.updatedText+' '+results.querySelector('[data-collection-count]').textContent;
          root.dispatchEvent(new CustomEvent('collection:updated',{bubbles:true}));
        }).catch(function(error){
          if(token!==sequence||error.name==='AbortError')return;
          root.removeAttribute('aria-busy');
          location.assign(url.toString());
        });
      }
      root.addEventListener('submit',function(event){
        var form=event.target.closest('[data-collection-form]');if(!form)return;
        event.preventDefault();request(formUrl(form),false,'push');
      });
      root.addEventListener('change',function(event){
        if(event.target.matches('[data-collection-sort]'))event.target.form.requestSubmit();
      });
      root.addEventListener('click',function(event){
        var guide=event.target.closest('[data-collection-guidance]');
        if(guide){var details=document.getElementById('CollectionGuidance');if(details&&details.tagName==='DETAILS')details.open=true;return;}
        var link=event.target.closest('[data-loadmore],[data-collection-link]');
        if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();event.stopPropagation();
        request(cleanUrl(link.href),link.hasAttribute('data-loadmore'),'push');
      });
      window.addEventListener('popstate',function(){if(root.isConnected)request(new URL(location.href),false,'none');});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
